import { Injectable } from '@angular/core';
import { IDocumentConfiguration } from '../request/document-uploader/_interfaces/DocumentConfiguration';


@Injectable({
  providedIn: 'root'
})
export class DocumentUploaderService {

constructor(
  //private commonService: CommonService
  ) { }

// GetDocumentsConfigurations(requestModel, CSharpModelName: string): IDocumentConfiguration[] {
//   this.commonService
//   .GetDocumentsConfigurations(requestModel, CSharpModelName).subscribe(
//         response => {
//           if (response['Status'] === 'Success') {
//             return response['Result'] !== null 
//             ? response['Result'] as IDocumentConfiguration[] : null;
//           } else {
//             console.error(response['Result']);
//             return null;
//           }
//         },
//         err => console.log(err)
//       );
//       return null;
// }


checkMandatoryDocument(docConfigs: IDocumentConfiguration[]): boolean {
  for (let i = 0; i < docConfigs.length; i++) {
    // this.isDocumentsMandatory = this.isDocumentsMandatory === false 
    // && this.docConfigs[i].isMandatory === true? true : false;

    if (docConfigs[i].IsMandatory === true) {
      return true;
    }
  }
  return false;
}


checkMandatoryUploadedEnhanced(docConfigs: IDocumentConfiguration[]): boolean {
  debugger;
 let mandatoryDocumentFoldersWithNoFiles =   docConfigs
      .filter((configuration: IDocumentConfiguration) => configuration.IsMandatory &&  configuration.Files.length <= 0);
  return mandatoryDocumentFoldersWithNoFiles.length <= 0;
}

checkMandatoryUploaded(docConfigs: IDocumentConfiguration[]): boolean {
  // debugger;


    for (let i = 0; i < docConfigs.length; i++) {
      if (
        // (
          docConfigs[i].IsMandatory 
        && !docConfigs[i].isDocConfigUploaded 
        // && docConfigs[i].DocumentType.Value === 1) || (docConfigs[i].IsMandatory 
        //   && !docConfigs[i].DocumentURL.URL 
        //   && docConfigs[i].DocumentType.Value === 2)
          ) {
        // this.isMandatoryStillNotUploaded = this.isMandatoryStillNotUploaded === false 
        // && this.docConfigs[i].isDocConfigUploaded === false ? true : false;
        return false;
      }
    }
    return true;
}

checkDocConfigsContainsFiles(docConfigs: IDocumentConfiguration[]): boolean {
  if (docConfigs) {
    for (let i = 0; i < docConfigs.length; i++) {
        if (docConfigs[i].Files !== null && docConfigs[i].Files.length > 0) {
          return true;
        }
      }
      return false;
  }
  else{
    return false;
  }

}

prepareDocConfigs(docConfigs: IDocumentConfiguration[]): IDocumentConfiguration[]{
  for (let i = 0; i < docConfigs.length; i++) {
    docConfigs[i].isDocConfigUploading = false;
    docConfigs[i].isDocConfigUploaded = false;

    docConfigs[i].MaxNumberOfAttach = docConfigs[i].MaxNumberOfAttach === undefined || docConfigs[i].MinNumberOfAttach === 0
    ? 0 : docConfigs[i].MaxNumberOfAttach;

    docConfigs[i].MinNumberOfAttach = 
    docConfigs[i].MinNumberOfAttach === undefined || docConfigs[i].MinNumberOfAttach === 0
    ? 1 : docConfigs[i].MinNumberOfAttach;

    docConfigs[i].DocumentType = docConfigs[i].DocumentType || {};
  }

  docConfigs.sort(function(docConfig, _docConfig){return docConfig.Sequence - _docConfig.Sequence});
  
  return docConfigs;
}

checkMandatoryLimitiation(docConfigs: IDocumentConfiguration[], NumberOfElement: number) {
  for (let i = 0; i < docConfigs.length; i++) {
    if (docConfigs !== null && docConfigs[i].Files !== null ) {
      if (docConfigs[i].isDocConfigUploaded && docConfigs[i].IsMandatory) {
        if (!this.checkFilesNumber(docConfigs[i], NumberOfElement)) {
          return false;
        }
      } 
    } else if (docConfigs !== null && docConfigs[i].IsMandatory && docConfigs[i].Files === null) {
      return false;
    }
  }
  return true;
}

// checkDocumentConfigurationsHaveFiles(docConfigs: IDocumentConfiguration[]): boolean{
//   if (docConfigs) {
//     for (let i = 0; i < docConfigs.length; i++) {
//       if (docConfigs && docConfigs[i].Files && docConfigs[i].Files.length > 0) {
//         return true;
//       } else {
//         return false;
//       }
//     }
//   }
//   else{
//     return false;
//   }
// }

  // -------------------
checkFilesNumber(docConfig: IDocumentConfiguration, NumberOfElement: number): boolean {
  let isNumberOfAttachmentsValid: boolean = true;
  isNumberOfAttachmentsValid = isNumberOfAttachmentsValid === true
  ? this.checkFilesMaxNumber(docConfig, NumberOfElement) : true;
  isNumberOfAttachmentsValid = isNumberOfAttachmentsValid === true
  ? this.checkFilesMinNumber(docConfig, NumberOfElement) : true;
  return isNumberOfAttachmentsValid;
}
checkFilesMaxNumber(docConfig: IDocumentConfiguration, NumberOfElement: number): boolean {
  if(docConfig.MaxNumberOfAttach != undefined && docConfig.MaxNumberOfAttach > 0)
  {
    if (docConfig.IsMaximumOverride) {
      return docConfig.Files.length <= (docConfig.MaxNumberOfAttach * NumberOfElement)
    ? true : false;
    } else {
      return docConfig.Files.length <= docConfig.MaxNumberOfAttach 
      ? true : false;
    }
  } else {
    return true;
  }
}
checkFilesMinNumber(docConfig: IDocumentConfiguration, NumberOfElement: number): boolean {
  if(docConfig.MinNumberOfAttach != undefined && docConfig.MinNumberOfAttach > 0)
  {
    if (docConfig.IsMaximumOverride) {
      return docConfig.Files.length >= (docConfig.MinNumberOfAttach * NumberOfElement)
    ? true : false;
    } else {
      return docConfig.Files.length >= docConfig.MinNumberOfAttach 
    ? true : false;
    }
  } else {
    if (docConfig.IsMaximumOverride) {
      return docConfig.Files.length >= (1 * NumberOfElement)
    ? true : false;
    } else {
      return docConfig.Files.length >= 1
    ? true : false;
    }
  }
}
 
}
